import React from 'react';
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import ColaCalculatorApp from '../components/tools/ColaCalculator';

const today = new Date();

const text = {
    mt: {
        year: `${today.getMonth() >= 10 ? today.getFullYear() : today.getFullYear() + 1}`,
        title: "COLA & Budget Report | Buddy",
        country: "Malta",
        description: "Malta Budget & Cost of Living Adjustment Impact Report: understand the impact of the annual budget on your Payroll.",
        canonical: "https://www.buddy.hr/uk/budget-report"
    },
    uk: {
        year: `${today.getMonth() >= 10 ? today.getFullYear() : today.getFullYear() + 1}/${today.getMonth() >= 10 ? today.getFullYear() + 1 : today.getFullYear() + 2}`,
        title: "UK Budget Report | Buddy",
        country: "UK",
        description: "UK Budget Impact Report: understand the impact of budget changes on Payroll.",
        canonical: "https://www.buddy.hr/mt/cola-report"
    }
}



function ColaReport({
    jurisdiction
}) {
  return (
    <React.Fragment>
      <Helmet>
        <title>{`${text[jurisdiction].year} ${text[jurisdiction].title}`}</title>
        <meta name="description" content={text[jurisdiction].description} />
        <link rel="canonical" href={text[jurisdiction].canonical} />
      </Helmet>
      <main className="mt-8 sm:mt-16 md:mt-20 lg:mb-24 mb-8 sm:mb-16 md:mb-20 lg:mb-24">
        <div className="grid grid-cols-2 sm:grid-cols-12 mx-auto max-w-screen-xl">

          <div className="col-span-10">
            <div className="max-w-7xl mx-auto py-4 px-4 sm:py-4 sm:px-6 lg:px-8 sm:text-center md:text-left lg:flex lg:justify-between">
              <div className="max-w-xl">
                <h2 className="text-4xl font-extrabold text-white sm:text-5xl sm:tracking-tight lg:text-6xl">
                  {text[jurisdiction].year} {text[jurisdiction].country} Budget Salary Impact Report
                </h2>
                <p className="mt-5 text-xl text-gray-400">
                  {text[jurisdiction].country}'s only employer-friendly budget report, generated using the same payroll engine which powers Buddy.
                </p>
              </div>
            </div>
          </div>
          <div className="col-span-12">
            <ColaCalculatorApp jurisdiction={jurisdiction}/>
          </div>
        </div>
      </main>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = dispatch => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ColaReport)
